const refundReview = {
    path: 'refund_review',
    component: resolve => require(['@/pages/admin/storage_audit/refund_review.vue'], resolve),
}

export default refundReview